import type { DarkModeType, TailwindViewportType, ViewportType } from '~/types/elementsUi'
import type { FAIconName } from '#shared/types/generated-icons'
import type { BaseTailwindColor } from '#shared/types/elementsUi'

export const textColorMap: Record<BaseTailwindColor, string> = {
  'dark-green': 'text-dark-green!',
  beige: 'text-beige!',
  gray: 'text-gray!',
  neutral: 'text-neutral!',
  pink: 'text-pink!',
  primary: 'text-primary!',
  secondary: 'text-secondary!',
  info: 'text-info!',
  success: 'text-success!',
  warning: 'text-warning!',
  danger: 'text-danger!',
  white: 'text-white!',
  black: 'text-black!',
  'pure-black': 'text-pure-black!'
}

export const viewportTailwindMapping: Record<ViewportType, TailwindViewportType> = {
  mobile: 'sm',
  tablet: 'md',
  desktop: 'lg',
  widescreen: 'xl',
  fullHD: '2xl'
}

export const darkModeIconMap: Record<DarkModeType, FAIconName> = {
  system: 'fa-circle-half-stroke',
  light: 'fa-sun',
  dark: 'fa-moon'
}
